


import React, { useState, useEffect,useRef } from 'react';
import axios from 'axios';
import { api_url } from '../config/config';
import DeletePrompt from "../Components/common/DeletePrompt";
function CategoryManagement() {
    const [categories, setCategories] = useState([]);
    const [formData, setFormData] = useState({ category_name: '', image_file: null });
    const [editingCategoryId, setEditingCategoryId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [categoryToDelete, setCategoryToDelete] = useState(null); 
    const fileInputRef = useRef(null); 
  
    useEffect(() => {
        fetchCategories();
    }, [currentPage]);

    const fetchCategories = () => {
        axios
            .get(`${api_url}/categories?page=${currentPage}&limit=100`,
                {
                    headers: { "Content-Type": "multipart/form-data ", 
          
                        'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
                    
                     },
                }
            )
            .then(response => {
                if (response.data.results) {
                    setCategories(response.data.results);
                    setTotalPages(response.data.totalPages);
                }
            })
            .catch(err => {
                alert(`Error fetching categories: ${err.message}`);
                console.error("Error fetching categories:", err);
            });
    };



    console.log("data" ,categories);
    
    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'image_file') {
            setFormData({ ...formData, [name]: files[0] });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleCreateCategory = () => {
        const isDuplicate = categories.some(
            (category) => category.category_name.toLowerCase() === formData.category_name.toLowerCase()
        );
    
        if (isDuplicate) {
            alert('Category name already exists!');
            console.warn('Category name already exists!');
            return;
        }
    
        const formDataToSend = new FormData();
        formDataToSend.append('category_name', formData.category_name);
        if (formData.image_file) {
            formDataToSend.append('file', formData.image_file);
        }
    
        axios
            .post(`${api_url}/category`, formDataToSend, {
                headers: { "Content-Type": "multipart/form-data ", 
          
                    'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
                
                 },
            })
            .then(response => {
                if (response.data.status === 'success') {
                    const newCategory = response.data.data;
                    setCategories([...categories, newCategory]);
                    // Clear form fields after category is created
                    setFormData({ category_name: '', file: null });
                    if (fileInputRef.current) {
                        fileInputRef.current.value = ""; // Clear file input field
                    }

                    fetchCategories();  // Optionally refetch categories
                }
            })
            .catch(err => {
                alert(`Error creating category: ${err.message}`);
                console.error("Error creating category:", err);
            });
    };
    

    const handleUpdateCategory = () => {
        const formDataToSend = new FormData();
        formDataToSend.append('category_name', formData.category_name);
        formDataToSend.append('category_id', editingCategoryId);

        if (formData.image_file) {
            formDataToSend.append('file', formData.image_file);
        }

        axios
            .patch(`${api_url}/category`, formDataToSend, {
                headers: { "Content-Type": "multipart/form-data ", 
          
                    'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
                
                 },
            })
            .then(response => {
                if (response.data.status === 'success') {
                    setCategories(
                        categories.map(category =>
                            category.category_id === editingCategoryId
                                ? { ...category, ...response.data.data }
                                : category
                        )
                    );
                    setFormData({ category_name: '', image_file: null });
                    if (fileInputRef.current) {
                        fileInputRef.current.value = ""; 
                    }
                    setEditingCategoryId(null);
                }
            })
            .catch(err => {
                alert(`Error updating category: ${err.message}`);
                console.error("Error updating category:", err);
            });
    };

    const handleDeleteCategory = () => {
        axios
            .delete(`${api_url}/category/${categoryToDelete}`,
                {
                    headers: { "Content-Type": "multipart/form-data ", 
          
                        'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
                    
                     },
                }
            )
            .then(response => {
                if (response.data.status === 'success') {
                    setCategories(categories.filter(category => category.category_id !== categoryToDelete));
                    setShowDeleteModal(false); // Close the delete modal after successful deletion
                } else {
                    alert(`Failed to delete category: ${response.data.message}`);
                    console.error(`Failed to delete category: ${response.data.message}`);
                }
            })
            .catch(err => {
                alert(`Error deleting category: ${err.message}`);
                console.error("Error deleting category:", err);
            });
    };

    const handleEditCategory = (category) => {
        setEditingCategoryId(category.category_id);
        setFormData({ category_name: category.category_name, image_file: null });
        if (fileInputRef.current) {
            fileInputRef.current.value = ""; 
        }
    };

    const handlePageChange = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    return (
        <div className="p-10">
            <h2 className="text-2xl font-semibold mb-5">Category Management</h2>

            <div className="mb-5">
                <input
                    type="text"
                    name="category_name"
                    value={formData.category_name}
                    onChange={handleInputChange}
                    placeholder="Enter category name"
                    className="border border-gray-300 rounded-lg p-2 mr-2"
                />
                <input
                    type="file"
                    name="image_file"
                    ref={fileInputRef} 
                    onChange={handleInputChange}
                    className="border border-gray-300 rounded-lg p-2 mr-2"
                />
                {editingCategoryId ? (
                    <button
                        onClick={handleUpdateCategory}
                        className="bg-[#3C1F1F] text-white px-4 py-2 rounded-lg"
                    >
                        Update Category
                    </button>
                ) : (
                    <button
                        onClick={handleCreateCategory}
                        className="bg-[#3C1F1F] text-white px-4 py-2 rounded-lg"
                    >
                        Create Category
                    </button>
                )}
            </div>

            <div className="flex flex-wrap justify-between gap-4">
  {categories.map((category) => (
    <div
      key={category.category_id}
      className="flex flex-col border border-gray-300 rounded-lg bg-white w-[calc(50%-0.5rem)]" // Ensures 2 items per row
    >
      <div className="flex justify-between items-center border rounded-lg p-4 border-green-700">
        <div className="flex items-center gap-4">
          {category.image_url ? (
            <img
              src={
                category.image_url.startsWith("http")
                  ? category.image_url
                  : `${api_url}${category.image_url}`
              }
              alt={category.category_name}
              className="w-20 h-10 object-cover"
            />
          ) : (
            <p>No image</p>
          )}
          <h3 className="text-lg font-semibold">{category.category_name}</h3>
        </div>
        <div className="flex gap-2">
          <button
                                onClick={() => handleEditCategory(category)}
                                className="bg-blue-500 text-lg font-semibold text-white px-4 h-[50px] rounded-lg"
                            >
                                Edit
                            </button>
                            <button
                                onClick={() => {
                                    setCategoryToDelete(category.category_id);
                                    setShowDeleteModal(true);
                                }}
                                className="bg-red-500 text-lg font-semibold text-white px-4 h-[50px] rounded-lg"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            ))}
        </div>

        <DeletePrompt
            showModal={showDeleteModal}
            onDelete={handleDeleteCategory}
            onCancel={() => setShowDeleteModal(false)}
        />
    </div>
);
};

export default CategoryManagement;
